import { useEffect, useState } from "react"
import { default as ModalProvider } from "react-modal"
import { getSettings, markWelcomeSeen } from "../../services/employer-service"
import { SettingsResponse } from "../../pages/settings/model"

const BULLETS = [
    {
        emoji: "📲",
        text: <>Trimiți jobul <b className="font-semibold text-figmaBlack">direct pe telefonul candidatului</b></>,
    },
    {
        emoji: "📅",
        text: <><b className="font-semibold text-figmaBlack">Organizezi evenimente de recrutare</b> și îți aduni candidații la un loc</>,
    },
    {
        emoji: "📈",
        text: <><b className="font-semibold text-figmaBlack">Promovezi</b> jobul, compania sau evenimentul pentru mai multă vizibilitate</>,
    },
]

export const WelcomeModal = () => {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        let cancelled = false
        getSettings()
            .then((settings: SettingsResponse) => {
                if (!cancelled && settings?.welcomeSeen === false) setIsOpen(true)
            })
            .catch(() => {})
        return () => { cancelled = true }
    }, [])

    // Închidem optimist: dacă apelul eșuează, popup-ul reapare la următorul login,
    // ceea ce e preferabil unui buton care pare blocat.
    const close = () => {
        setIsOpen(false)
        markWelcomeSeen().catch(() => {})
    }

    return (
        <ModalProvider
            appElement={document.getElementById("root")!}
            isOpen={isOpen}
            onRequestClose={close}
            className="mx-4 my-auto max-h-[90vh] w-full max-w-[460px] overflow-y-auto rounded-2xl bg-white outline-none"
            overlayClassName="fixed inset-0 z-[60] flex items-center justify-center bg-gray-800/60 p-4"
        >
            <div className="p-6 sm:p-8">
                <h3 className="text-center text-xl font-bold text-figmaBlack">
                    Bine ai venit în Jobbin! 🚀
                </h3>
                <p className="mt-2 text-center text-sm text-figmaDarkGray leading-relaxed">
                    Aici nu aștepți CV-uri — tu alegi candidatul și îl chemi la tine.
                </p>

                <ul className="mt-6 flex flex-col gap-4">
                    {BULLETS.map((bullet) => (
                        <li key={bullet.emoji} className="flex items-start gap-3">
                            <span className="text-xl leading-none mt-0.5" aria-hidden="true">{bullet.emoji}</span>
                            <span className="text-sm text-figmaDarkGray leading-relaxed">{bullet.text}</span>
                        </li>
                    ))}
                </ul>

                <button
                    type="button"
                    onClick={close}
                    className="mt-7 w-full rounded-xl bg-figmaPrimary px-4 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90"
                >
                    Am înțeles
                </button>
            </div>
        </ModalProvider>
    )
}

export default WelcomeModal
